import { render, staticRenderFns } from "./tablePastMeetings.vue?vue&type=template&id=d04a8fb2&"
import script from "./tablePastMeetings.vue?vue&type=script&lang=js&"
export * from "./tablePastMeetings.vue?vue&type=script&lang=js&"
import style0 from "./tablePastMeetings.vue?vue&type=style&index=0&id=d04a8fb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports